import {languageNamePipe, LanguageNamePipe} from "./language-name/LanguageNamePipe";
import {languageClassPipe, LanguageClassPipe} from "./language-class/LanguageClassPipe";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.pipes`;

    return angular.module(moduleName, [])
                  .filter(LanguageNamePipe, languageNamePipe)
                  .filter(LanguageClassPipe, languageClassPipe)
                  .name;
}
